import React from 'react';
import './WhoIsFor.css';

const targetAudience = [
  "Analysts tired of Googling formulas",
  "Finance professionals building models",
  "Researchers cleaning datasets",
  "Operators handling messy spreadsheets",
  "Anyone who wants results, not tutorials"
];

function WhoIsFor() {
  return (
    <section className="who-is-for section">
      <div className="container">
        <h2 className="section-title">Who This Is For</h2>
        <ul className="audience-list">
          {targetAudience.map((item, index) => (
            <li key={index}>
              <svg className="bullet-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default WhoIsFor;
